import './parts/gsap.min.js';
import './parts/ScrollTrigger.min.js';
import './parts/kianimate.js';